import axios from "@/plugins/axios";


export default {
    list(creditor_id, paginacao){
        if(paginacao.descending){
            paginacao.sortBy = '-'+paginacao.sortBy
        }
        let params = {
            page: paginacao.page,
            limit: paginacao.rowsPerPage,
            order: (paginacao.sortBy)?paginacao.sortBy:'updated_at'
        }
        if (creditor_id && creditor_id !== '') {
            params.creditor = creditor_id
        }
        return axios.httpApi.get("/potentials", {params:params});
    },
    create(potential){ 
        return axios.httpApi.post("/potentials", potential);
    } ,
    update(id, alteracoes){ 
        return axios.httpApi.patch("/potentials/"+ id, alteracoes);
    },
    remove(id){ 
        return axios.httpApi.delete("/potentials/"+ id);
    }   
}